export default __webpack_public_path__ + "static/media/FAA-Logo.0c63c909.png";